export class GroupUser {
  data = null;
  user_id = null;
  name = null;
  group_id = null;
}
